module.exports = __webpack_public_path__ + "static/media/play_arrow.f089ea3d.svg";